module.exports = __webpack_public_path__ + "img/appAsset--customer-contact-ax.604af039.svg";